<div class="flex items-center justify-center dialog-header ">
    Delete Email Configuration

    <div class="absolute right-2">
        <button (click)="handleCloseDialog()" class="outline-none p-5">
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>

<div class="dialog-content">
    <div class="text-center font-medium text-lg">
        Are you sure you want delete the email configuration ?
    </div>

    <div class="flex gap-4 mt-7 justify-end">

        <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()"></p-button>
        <p-button label="Delete"
        severity="danger"
        icon="pi pi-trash"
        (click)="handleDeleteDepartment()" [disabled]="isLoading"
            [loading]="isLoading">
        </p-button>
        

    </div>

</div>